var path = 'C:/Projects/repos/NAERS-Web/src/components/app/reports/admins-by-category-pie/admins-by-category-pie.html';
var html = "<div layout=column> <report-form on-report-generated=$ctrl.generateReport($event)> </report-form> <highchart class=naers-report config=$ctrl.chartConfig ng-if=\"$ctrl.chartConfig && $ctrl.chartConfig.series\" style=overflow:hidden></highchart> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./components/app/reports/admins-by-category-pie/admins-by-category-pie.html
// module id = 705
// module chunks = 0